export function fileNamebyUrl(url, withExt = true) {
  const path = url.split('?')[0]
  const arr = path.split('/')

  let filename = arr[arr.length - 1]
  if (!withExt) {
    filename = filename.substring(0, filename.lastIndexOf('.'))
  }

  return filename
}

export function getUuid() {
  let len = 32 //32长度
  let radix = 16 //16进制
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
    '',
  )
  let uuid = [],
    i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | (Math.random() * radix)]
    }
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

export function formatTime(date) {
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
  let D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate());
  return Y+M+D;
}

// export function clearStorage() {
//   localStorage.clear()
// }

// export function setStorageItem(key, value) {
//   localStorage.setItem(key, JSON.stringify(value))
// }

// export function getStorageItem(key) {
//   const item = localStorage.getItem(key)
//   const value = JSON.parse(item)
//   return value
// }

// export function setToken(token) {
//   setStorageItem('token', token)
// }

// export function getToken() {
//   const token = getStorageItem('token')
//   return token
// }

// export function setFormConfigId(value) {
//   setStorageItem('formConfigId', value)
// }

// export function getFormConfigId() {
//   const result = getStorageItem('formConfigId')
//   return result
// }
